<template>
  <div>
    <!-- 退款预警 -->
    <div class="shadowWrapper">
      <div class="commentWarning">
        <div class="headTitle">退款预警</div>
        <div class="tabContent">
          <!-- 描述 -->
          <div class="desc">
            <img src="@/assets/images/refundWarning_icon.png" alt="" class="img">
            <span>当买家有申请退款时，提醒商家，及时处理</span>
          </div>
          <!-- 头部导航栏 -->
          <div class="tabList">
            <span :class="{ 'active': tabActiveIndex == 1 }" @click="tabActiveIndex = 1">退款预警</span>
            <span :class="{ 'active': tabActiveIndex == 2 }" @click="tabActiveIndex = 2">短信记录</span>
            <i></i>
          </div>
        </div>
        <!-- 退款预警 -->
        <warning pageName="售后中心-退款预警" v-show="tabActiveIndex === 1"></warning>

        <!-- 短信记录 -->
        <sms-record v-show="tabActiveIndex === 2"></sms-record>
      </div>
    </div>
  </div>
</template>

<script>
import warning from './components/warning'
import smsRecord from './components/smsRecord'

export default {
  components: {
    warning,
    smsRecord
  },
  data() {
    return {
      tabActiveIndex: 1
    }
  },
  created() {
    // 埋点
    this.buriedPoint(1, '退款预警', '售后中心', '掌柜预警')
  }
}
</script>

<style scoped lang="scss">
.shadowWrapper {
  box-sizing: border-box;
  padding: 10px 20px 45px;
  min-width: 1080px;
}

.commentWarning {
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;

  .headTitle {
    box-sizing: border-box;
    padding-left: 28px;
    height: 54px;
    line-height: 53px;
    border-bottom: 1px solid #F0F0F0;
    color: #2E3458;
    font-size: 16px;
    font-weight: bold;
  }

  .tabContent {
    box-sizing: border-box;
    padding: 20px 28px 0;

    .desc {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 12px 16px;
      background-color: #FFF6F6;
      color: #666;
      font-size: 14px;
      font-weight: 400;

      .img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
    }

    .tabList {
      display: flex;
      box-sizing: border-box;
      height: 36px;
      line-height: 35px;
      margin-top: 20px;
      color: #999;
      font-size: 14px;

      span {
        width: 106px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        vertical-align: middle;
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        border-radius: 2px 2px 0px 0px;
        border: 1px solid #DDDDDD;
        text-align: center;
      }

      .active {
        position: relative;
        transition: all .2s;
        color: #FE4D45;
        border-bottom: none;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          top: 0;
          height: 2px;
          background: #FE4D45;
          border-radius: 6px 6px 0px 0px;
        }

      }

      i {
        flex: 1;
        border-bottom: 1px solid #F6F6F6;
      }
    }
  }

}</style>